import React, { ReactNode } from "react";
import { KUBRA_TERMS_OF_USE_URL, KUBRA_PRIVACY_POLICY_URL } from "constants/externalUrls";

export const TermsLink = (props: { children?: ReactNode }) => (
  <a
    className="terms-and-privacy-text"
    href={KUBRA_TERMS_OF_USE_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-cy="button-terms-link"
  >
    {props.children}
  </a>
);

export const PrivacyLink = (props: { children?: ReactNode }) => (
  <a
    className="terms-and-privacy-text"
    href={KUBRA_PRIVACY_POLICY_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-cy="button-privacy-link"
  >
    {props.children}
  </a>
);

export default { TermsLink, PrivacyLink };
